// This file was automatically generated from appchart.refpanel.ptRegistrationInfo.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.refpanel.ptRegistrationInfo');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.ptRegistrationInfo.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.isPatientUserDisabled) ? '<a class="el8PassportStatusNo"><span class="el8PassportIconNo"></span>Disabled</a>' : (opt_data.inviteStatus == 'NOT_INVITED') ? '<a class="passport-invite-trigger el8PassportStatusNo"><span class="el8PassportIconNo"></span>Passport</a>' : (opt_data.inviteStatus == 'INVITED') ? '<a class="passport-invite-trigger el8PassportStatusInvited"><span class="el8PassportIconInvited"></span>Passport</a>' : (opt_data.inviteStatus == 'USED') ? '<a class="passport-invite-trigger el8PassportStatusYes"><span class="el8PassportIconYes"></span>Passport</a>' : '');
  if (!opt_sb) return output.toString();
};
